import Vue from 'vue';
import { beforeRouteEnter } from '@assets/js/routerPageHook.js';
import filterContainer from '@components/ui-components/filter-container/filter-container.vue';
import onScrollAnimate from '@assets/js/scrollAnimate.js';
import LoadMore from '@components/ui-components/load-more/load-more';
// import formGreen from '@components/base/form-green.vue';
// import filterSearch from '@components/ui-components/filter-search/filter-search.vue';
import { mapState } from "vuex";
import {router} from "@src/routes";

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',
            activeView: false,
            newCategories: [],
            pagination: null,
            disableLoadMore: false,
        }
    },
    components: {
        'filter-container-cmp': filterContainer,
        'load-more-cmp': LoadMore,
        // 'form-green-cmp': formGreen,
        // 'filter-search-cmp': filterSearch,
    },
    watch: {
        activeView() {
            setTimeout(() => {
                onScrollAnimate();
            }, 300);
        }
    },
    computed: {
        ...mapState('mobile', ['isMobile']),
    },
    methods: {
        setPagination() {
            setTimeout(() => {
                this.pagination = this.$root.convertTwigToJs(
                    'pagination',
                    '.js-pagination'
                );
            }, 100);
        },
    },
    mounted() {
        this.setPagination();
        if (this.isMobile) {
            setTimeout(() => {
                this.activeView = false;
            }, 1500);
        }
    },
    beforeRouteUpdate(to, from, next) {
        // если не loadMore
        if (!to.query.loadMore) {
            const path = to.path.replace(router.history.base, '');
            this.$root.setDataAnimateFalse();

            Vue.http.get(`templates${path}`, { params: to.query }).then(
                (data) => {
                    next();
                    setTimeout(() => {
                        this.template = data.data;
                        this.newCategories = [];
                        this.setPagination();
                        // setTimeout(() => {
                        //     onScrollAnimate();
                        // }, 100);
                    }, 500);
                },
                () => {
                    next('/404');
                }
            );
        } else {
            this.disableLoadMore = true;
            let url = process.env.NODE_ENV !== 'production' ?
                'vendors/index.json' :
                to.path.substring(1).replace(router.history.base, '');

            Vue.http.get(url, { params: to.query }).then(
                (data) => {
                    next();
                    this.newCategories = this.newCategories.concat(data.data.items);
                    this.pagination = data.data.pagination;
                    this.disableLoadMore = false;
                    setTimeout(() => {
                        onScrollAnimate();
                    }, 10);
                },
                () => {
                    this.disableLoadMore = false;
                    next('/404');
                }
            );
        }
    },
    beforeRouteEnter,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};


// WEBPACK FOOTER //
// ./src/templates/pages/decisions/category/index.js